import React, { useMemo, useState } from 'react';
import { Table, Tooltip } from 'antd';
import { useUnit } from 'effector-react';
import { $overviewStore } from '../../models/overviewModel/index.js';
import { changeRegionsOkedsModalEv } from '../../models/investProjectsModel/index.js';
import styles from './InvestProjects.module.css';
import { GearRevert } from '../../utils/customIcons.jsx';
import PhaseBarComponent from '../PhaseBarComponent/PhaseBarComponent.jsx';

const phasesNames = {
  1: '1 стадия',
  2: '2 стадия',
  3: '3 стадия',
  // 1: '1 стадия Прединвестиционная',
  // 2: '2 стадия Инвестиционная',
  // 3: '3 стадия Эксплуатационная',
};

const kpiDict = {
  kpi_1: 'От бизнес плана к финансированию',
  kpi_2: 'Ввод в эксплуатацию',
};

function InvestProjectsChart() {
  const { projects } = useUnit($overviewStore);
  const { kpi_chart, phase_chart, phase_data } = projects;
  const changeRegionsOkedsModal = useUnit(changeRegionsOkedsModalEv);

  const [selectPhase, setSelectPhase] = useState(null);

  const totalCardsProps = {
    project_count: {
      title: 'Кол-во проектов',
      width: '25%',
      render: (n) =>
        Number.isNaN(n)
          ? n
          : new Intl.NumberFormat('ru-RU', { notation: 'compact' })
              .format(totalData.project_count)
              .split(' ')[0],
      unit: 'тысяч',
    },

    post_invest_work_places: {
      title: 'Кол-во раб. мест в экспл. период',
      width: '35%',
      render: (n) =>
        Number.isNaN(n)
          ? n
          : new Intl.NumberFormat('ru-RU', { notation: 'compact' })
              .format(n)
              .split(' ')[0],
      unit: 'тысяч',
    },
    post_invest_taxes: {
      title: 'Налоги в экспл. период',
      width: '35%',
      render: (n) =>
        Number.isNaN(n)
          ? n
          : new Intl.NumberFormat('ru-RU', {
              notation: 'standard',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(n / 1000),
      unit: 'млрд.',
    },
  };

  const totalData = useMemo(
    () =>
      Object.keys(phase_chart).reduce(
        (a, b) => {
          if (phase_chart[b].effects) {
            return {
              project_count: a.project_count + phase_chart[b].count,
              // invest_work_places: a.invest_work_places + phase_chart[b].effects[1].investment_period,
              post_invest_work_places:
                a.post_invest_work_places +
                phase_chart[b].effects[1].post_investment_period,
              // invest_taxes: phase_chart[b].effects[2] ? a.invest_taxes + phase_chart[b].effects[2].investment_period : a.invest_taxes,
              post_invest_taxes: phase_chart[b].effects[2]
                ? a.post_invest_taxes +
                  phase_chart[b].effects[2].post_investment_period
                : a.post_invest_taxes,
            };
          }
          return a;
        },
        {
          project_count: 0,
          // invest_work_places: 0,
          post_invest_work_places: 0,
          // invest_taxes: 0,
          post_invest_taxes: 0,
        }
      ),
    [phase_chart]
  );

  const phasesColumns = [
    {
      title: '',
      key: 'phase',
      dataIndex: 'phase',
      width: '20%',
      textWrap: 'word-break',
      render: (phase) => (
        <Tooltip title={phasesNames[phase]}>
          <span style={{ fontWeight: 700, fontSize: 16 }}>
            {phasesNames[phase]}
          </span>
        </Tooltip>
      ),
    },
    {
      title: (
        <span style={{ fontWeight: 700, fontSize: 16 }}>Кол-во проектов</span>
      ),
      align: 'center',
      key: 'project_count',
      dataIndex: 'project_count',
      width: '25%',
      render: (text) => (
        <span style={{ fontWeight: 700, fontSize: 16 }}>
          {Number.isNaN(text)
            ? text
            : new Intl.NumberFormat('ru-RU', { notation: 'compact' }).format(
                text
              )}
        </span>
      ),
    },
    // {
    //   title: 'Кол-во рабочих мест в инвест. период',
    //   key: 'invest_work_places',
    //   dataIndex: 'invest_work_places',
    //   align: 'center',
    //   render: (text) =>
    //     Number.isNaN(text)
    //       ? text
    //       : new Intl.NumberFormat('ru-RU', { notation: 'compact' }).format(
    //           text
    //         ),
    // },
    // {
    //   title: 'Налоги в инвест период млрд.тнг',
    //   key: 'invest_taxes',
    //   dataIndex: 'invest_taxes',
    //   align: 'center',
    //   // render: (invest_taxes) => (invest_taxes / 1000000000).toFixed(2),
    //   render: (val) =>
    //     Number.isNaN(val)
    //       ? val
    //       : new Intl.NumberFormat('ru-RU', {
    //           notation: 'standard',
    //           minimumFractionDigits: 2,
    //           maximumFractionDigits: 2,
    //         }).format(val / 1000),
    // },
    {
      title: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            alignItems: 'center',
          }}
        >
          <span style={{ fontWeight: 700, fontSize: 16 }}>Кол-во</span>
          <span>раб. мест</span>
        </div>
      ),
      align: 'center',
      key: 'post_invest_work_places',
      dataIndex: 'post_invest_work_places',
      width: '30%',
      render: (text) => (
        <span style={{ fontWeight: 700, fontSize: 16 }}>
          {Number.isNaN(text)
            ? text
            : new Intl.NumberFormat('ru-RU', { notation: 'compact' }).format(
                text
              )}
        </span>
      ),
    },
    {
      title: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            alignItems: 'center',
          }}
        >
          <span style={{ fontWeight: 700, fontSize: 16 }}>Налоги</span>
          <span style={{ fontWeight: 700, fontSize: 16 }}>(млрд тг)</span>
        </div>
      ),
      align: 'center',
      key: 'post_invest_taxes',
      dataIndex: 'post_invest_taxes',
      render: (text) => (
        <span style={{ fontWeight: 700, fontSize: 16 }}>
          {Number.isNaN(text)
            ? text
            : new Intl.NumberFormat('ru-RU', { notation: 'compact' }).format(
                text
              )}
        </span>
      ),
    },
  ];

  const phasesData = useMemo(
    () =>
      Object.keys(phase_chart).map((key) => {
        return {
          phase: key,
          project_count: phase_chart[key].count,
          invest_work_places:
            phase_chart[key].effects && phase_chart[key].effects[1]
              ? phase_chart[key].effects[1].investment_period
              : 0,
          post_invest_work_places:
            phase_chart[key].effects && phase_chart[key].effects[1]
              ? phase_chart[key].effects[1].post_investment_period
              : 0,
          invest_taxes:
            phase_chart[key].effects && phase_chart[key].effects[2]
              ? phase_chart[key].effects[2].investment_period
              : 0,
          post_invest_taxes:
            phase_chart[key].effects && phase_chart[key].effects[2]
              ? phase_chart[key].effects[2].post_investment_period
              : 0,
        };
      }),
    [phase_chart]
  );

  const kpiData = useMemo(
    () =>
      Object.keys(kpi_chart).map((item) => {
        return {
          name: kpiDict[item],
          count: kpi_chart[item],
        };
      }),
    [kpi_chart]
  );

  return (
    <div className={styles.cnt}>
      <div className={'flex-between'}>
        {Object.entries(totalData).map(([key, value]) => (
          <div
            className={styles.statCard}
            style={
              totalCardsProps[key]?.width
                ? { width: totalCardsProps[key].width }
                : {}
            }
          >
            <span>{totalCardsProps[key]?.title}</span>
            <div className={styles.numCnt}>
              <span className={styles.number}>
                {totalCardsProps[key]?.render(value)}
              </span>
              <span className={styles.unit}>{totalCardsProps[key]?.unit}</span>
            </div>
          </div>
        ))}
      </div>
      <Table
        columns={phasesColumns}
        prefixCls={styles.table}
        dataSource={phasesData}
        pagination={false}
        size={'small'}
        rowClassName={'pointer'}
        onRow={(record) => {
          return {
            // onClick: (e) => changeRegionsOkedsModal(true),
            onClick: () => setSelectPhase(record.phase),
          };
        }}
      />
      <div className={styles.kpiCnt}>
        {/*<div className={styles.kpiTitle}>*/}
        {/*  {GearRevert} KPI конверсии проектов*/}
        {/*</div>*/}

        {selectPhase === null ? (
          <div className={styles.kpiCardsCnt}>
            {kpiData.map((i, idx) => (
              <div className={styles.kpiCard} key={i.name}>
                <span className={styles.kpiIdx}>{`KPI-${idx + 1}`}</span>
                <span className={styles.kpiCardTitle}>{i.name}</span>
                <div className={styles.kpiUnitCnt}>
                  <span className={styles.kpiCardNumber}>{i.count}</span>
                  <span className={styles.kpiCardUnit}>проектов</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <PhaseBarComponent
            data={phase_data}
            onClose={() => setSelectPhase(null)}
            phase={selectPhase}
          />
        )}

        {/*<div className={styles.kpiCardsCnt}>*/}
        {/*  {kpiData.map((i, idx) => (*/}
        {/*    <div className={styles.kpiCard} key={i.name}>*/}
        {/*      <span className={styles.kpiIdx}>{`KPI-${idx + 1}`}</span>*/}
        {/*      <span className={styles.kpiCardTitle}>{i.name}</span>*/}
        {/*      <div className={styles.kpiUnitCnt}>*/}
        {/*        <span className={styles.kpiCardNumber}>{i.count}</span>*/}
        {/*        <span className={styles.kpiCardUnit}>проектов</span>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  ))}*/}
        {/*</div>*/}
      </div>
    </div>
  );
}

export default InvestProjectsChart;
